import type { AxiosInstance } from 'axios';

import Vue from 'vue';

import { formatPhone } from '@/utils/phone';

import { useApi } from '@/api/composable';

export interface UserAccount {
  name: string
  avatarLink?: string
  phone: string
  isInvestor: boolean
  companyId: string
  sessionId?: string
  withoutAuth?: boolean
};

export interface UserCompaniesRegistry {
  investor: UserAccount | null
  borrower: UserAccount | null
}

export const useAccountsStore = defineStore('users', () => {
  const http = Vue.http as AxiosInstance;

  const {
    data,
    isLoading,
    execute,
    error,
  } = useApi(
    http,
    'admin/users/account/get_logins',
    { method: 'GET', localErrorHandle: true }
  );

  const currentUserCompanies = shallowRef<UserCompaniesRegistry>({
    borrower: null,
    investor: null,
  });
  function setUserCompanies(payload: UserCompaniesRegistry) {
    currentUserCompanies.value = payload;
  }

  const rawList = computed<UserAccount[]>(() => {
    if (Array.isArray(data.value?.response)) {
      return data.value.response.map((r: Record<string, unknown>) => ({
        name: r.name,
        avatarLink: r['user-avatar'],
        phone: formatPhone(r.login as string),
        isInvestor: (r.type as string).includes('invest'),
        companyId: r.comp_id,
        sessionId: r.dev_sesh_id,
      } as UserAccount));
    }
    return [];
  });

  const list = computed(() => {
    /*
    тут есть некоторая тупость: бэкенд возвращает список всех у кого установлен пин-код,
    а отображать нам надо их + текущего пользователя, даже если у него пин не установлен,
    но при этом нам и дубликаты не нужны
    */
    const currentUserCompaniesList = Object.values(currentUserCompanies.value).filter((c) => !!c);
    const currentUserCompanyIds = currentUserCompaniesList.map((acc) => acc.companyId);
    const listToSort = rawList.value?.filter((acc) => !currentUserCompanyIds.includes(acc.companyId));
    /* listToSort.sort((a, b) => +a.phone.slice(-2) - +b.phone.slice(-2)); */

    return [...currentUserCompaniesList, ...listToSort];
  });

  return {
    rawList,
    list,
    isLoading,
    error,

    init: execute,
    update: execute,
    execute,
    setUserCompanies,
  };
});
